/**
 * Lead-capture modal event bus.
 * Any CTA can open the Book-a-Demo or Join-Waitlist modal without prop drilling.
 * The modals are mounted once (in PublicHeader) and listen for these events.
 */
export const DEMO_MODAL_EVENT = 'corvana:open-demo-modal';
export const WAITLIST_MODAL_EVENT = 'corvana:open-waitlist-modal';

export function openDemoModal() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(DEMO_MODAL_EVENT));
  }
}

export function openWaitlistModal(interest = 'early_access') {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(WAITLIST_MODAL_EVENT, { detail: { interest } }));
  }
}
